import React from 'react';

import Button from 'CommonComponents/Button';
import RowActionsMenu from 'CommonComponents/RowActionsMenu';
import SegmentedControl from 'CommonComponents/SegmentedControl';
import TextButton from 'CommonComponents/TextButton';

import PenIcon from 'Assets/icons/pen-simple.svg';
import PlusIcon from 'Assets/icons/plus.svg';

export const VIEW_ALLOCATE = 'allocate';
export const VIEW_SUMMARY = 'summary';

/** Report title (rename on hover), Allocate / Summary, expand controls, Add column and the report menu. */
export default function ReportHeader({
    report,
    view,
    onViewChange,
    onExpandAll,
    onCollapseAll,
    onAddColumn,
    onRename,
    onDuplicate,
    onDelete,
    abilities,
    busy,
}) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-border-b tw-border-grey tw-px-5 tw-py-3.5">
            <div className="tw-group tw-flex tw-items-center tw-gap-x-2">
                <h2 className="tw-m-0 tw-text-lg tw-font-semibold tw-text-charcoal">{report.title}</h2>
                {abilities.update && (
                    <button
                        type="button"
                        onClick={onRename}
                        title={$t('Rename report')}
                        aria-label={$t('Rename report')}
                        className="tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-charcoal-50 tw-opacity-0 hover:tw-bg-charcoal-15 hover:tw-text-charcoal focus:tw-opacity-100 group-hover:tw-opacity-100"
                    >
                        <PenIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                    </button>
                )}
            </div>
            <SegmentedControl
                variant="inset"
                className="tw-ms-3"
                value={view}
                onChange={onViewChange}
                options={[
                    { value: VIEW_ALLOCATE, label: $t('Allocate') },
                    { value: VIEW_SUMMARY, label: $t('Summary') },
                ]}
            />
            <div className="tw-ms-auto tw-flex tw-flex-wrap tw-items-center tw-gap-x-3">
                <TextButton className="!tw-normal-case" variant="primary" onClick={onExpandAll}>
                    {$t('Expand all')}
                </TextButton>
                <TextButton className="!tw-normal-case" variant="primary" onClick={onCollapseAll}>
                    {$t('Collapse all')}
                </TextButton>
                {abilities.update && view === VIEW_ALLOCATE && (
                    <Button variant="primary" small onClick={onAddColumn} disabled={busy}>
                        <PlusIcon className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />
                        {$t('Add column')}
                    </Button>
                )}
                <RowActionsMenu
                    actions={[
                        abilities.update && { key: 'rename', label: $t('Rename report'), onClick: onRename },
                        abilities.create && { key: 'duplicate', label: $t('Duplicate report'), onClick: onDuplicate },
                        abilities.delete && { key: 'delete', label: $t('Delete report'), onClick: onDelete },
                    ]}
                />
            </div>
        </div>
    );
}
